module.exports = __webpack_public_path__ + "media/fonts/fa-regular-400-5a00215b79999f94c445bcee9ee26c7d.svg";